(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root) return;
  root.CeikaCartRecommendations = api;
  if (customElements.get('ceika-reviewed-offers')) return;

  let catalogueRequest;
  async function related(element) {
    const url = element.dataset.catalogue;
    if (!url) return;
    catalogueRequest ||= fetch(url).then(r => {
      if (!r.ok) throw Error('catalogue');
      return r.json();
    }).catch(error => { catalogueRequest = null; throw error; });
    const records = await catalogueRequest;
    if (!element.isConnected) return;
    const excluded = new Set((element.dataset.carted || '').split(','));
    for (const source of element.querySelectorAll('[data-source]')) {
      const s = source.dataset;
      const group = records.find(row => row[6].some(([id,,,identity]) => id === s.id && identity === s.identity));
      if (!group) continue;
      const [vehicle,make,model,trim,start,end,products] = group;
      const current = products.find(([id]) => id === s.id);
      const candidates = products.filter(([id,,family]) => id !== s.id && family !== current[2] && !excluded.has(id));
      if (!candidates.length) continue;
      const lastYear = Math.min(end, new Date().getFullYear()+1);
      if (start > lastYear) continue;
      const isPage = element.hasAttribute('data-product');
      const query = new URLSearchParams(location.search);
      const selectedId = isPage ? query.get('vehicle') : s.vehicle;
      const selectedYear = isPage ? query.get('year') : s.year || s.modelYear;
      if (selectedId && selectedId.replaceAll('-','') !== vehicle.replaceAll('-','')) continue;
      if (s.trim && s.trim !== trim) continue;
      const section = document.createElement('div');
      section.className = 'ceika-related-line';
      const label = document.createElement('label');
      label.textContent = [make,model,trim,'·',element.dataset.yearLabel].join(' ');
      const select = document.createElement('select');
      select.add(new Option('—',''));
      for (let y = start; y <= lastYear; y++) select.add(new Option(String(y),String(y)));
      label.append(select);
      const slot = document.createElement('div');
      section.append(label,slot);
      element.querySelector('[data-related-list]').append(section);
      element.hidden = false;
      let version = 0;
      async function choose() {
        const run = ++version;
        slot.replaceChildren();
        const year = Number(select.value);
        if (isPage) delete element.dataset.selectedYear;
        if (!select.value || year < start || year > lastYear) return;
        if (isPage) element.dataset.selectedYear = select.value;
        const rootPath = window.Shopify?.routes?.root || '/';
        if (!/^\/(?:[a-z0-9-]+\/)*$/i.test(rootPath)) return;
        for (const [id, handle,,identity] of candidates.slice(0,4)) {
          if (!/^[a-z0-9_-]+$/i.test(handle)) continue;
          const target = new URL(rootPath+'products/'+handle, location.origin);
          const theme = window.Shopify?.theme;
          if (['unpublished','development'].includes(theme?.role)) target.searchParams.set('preview_theme_id',theme.id);
          const view = new URL(target);
          view.searchParams.set('view','ceika-related-card');
          let data;
          try {
            const r = await fetch(view,{credentials:'same-origin',cache:'no-store'});
            if (!r.ok) continue;
            data = await r.json();
          } catch { continue; }
          if (version !== run || !element.isConnected) return;
          if (String(data.id)!==id || data.identity!==identity ||
              data.available!==true || data.currency!==element.dataset.currency || !data.title) continue;
          // Shopify can translate the handle while keeping the exact native product identity.
          if (typeof data.handle !== 'string' || !/^[\p{L}\p{N}_-]+$/u.test(data.handle) ||
              typeof data.url !== 'string' || !data.url.startsWith(rootPath+'products/')) continue;
          let localized;
          try {
            localized = new URL(data.url,location.origin);
            if (localized.origin !== location.origin ||
                decodeURIComponent(localized.pathname) !== rootPath+'products/'+data.handle) continue;
          } catch { continue; }
          target.pathname = localized.pathname;
          const article = document.createElement('article');
          article.className = 'ceika-cart-offer';
          if (data.image) {
            const imageURL = new URL(data.image, location.origin);
            if (imageURL.protocol === 'https:' || imageURL.origin === location.origin) {
              const img = document.createElement('img');
              img.src=imageURL.href; img.alt=''; img.loading='lazy'; article.append(img);
            }
          }
          const body = document.createElement('div');
          const title = document.createElement('strong');
          title.textContent = data.title;
          const note = document.createElement('span');
          note.textContent = element.dataset.note;
          const link = document.createElement('a');
          target.searchParams.set('vehicle',vehicle); target.searchParams.set('year',String(year));
          link.href=target.href; link.textContent=element.dataset.view+' →';
          body.append(title,note);
          if (data.price > 0 && data.priceFormatted) {
            const price = document.createElement('span');
            price.textContent = element.dataset.from+' '+data.priceFormatted;
            body.append(price);
          }
          body.append(link); article.append(body); slot.append(article);
          break;
        }
      }
      if (selectedYear && (!isPage || selectedId) && (isPage || !selectedId || s.trim === trim)) select.value=String(selectedYear);
      select.addEventListener('change',choose);
      if (select.value) void choose();
    }
  }

  class ReviewedOffers extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.render());
    }
    render() {
      const output = this.querySelector('[data-offer-list]');
      if (!output || this.dataset.rendered) return;
      this.dataset.rendered = "true";
      const templates = new Map();
      const vehiclesById = {};
      const products = Array.from(this.querySelectorAll('template[data-candidate]'), node => {
        const {id, family, vehicle, trim, start, end, available} = node.dataset;
        const custom = family === 'forged_wheels';
        const assignments = [];
        if (!custom) {
          vehiclesById[vehicle] = {variant:trim, start_year:Number(start), end_year:Number(end), status:'reviewed'};
          assignments.push({vehicle_id:vehicle, variant:trim, year_start:Number(start), year_end:Number(end), decision:'reviewed'});
        }
        templates.set(id, node);
        return {id, family, assignments, available:available === 'true', match_mode:custom ? 'custom' : 'vehicle'};
      });
      const sources = Array.from(this.querySelectorAll('template[data-source]'), node => {
        const data = node.dataset;
        let vehicle = data.vehicle, year = data.year, trim = data.trim;
        if (this.hasAttribute('data-product')) {
          const query = new URLSearchParams(location.search);
          vehicle = query.get('vehicle');
          year = query.get('year');
          trim = vehiclesById[vehicle]?.variant;
        }
        return {key:data.key, product_id:data.id, title:data.title, properties:{
          _ceika_vehicle_id:vehicle, _ceika_vehicle_year:year, _ceika_vehicle_trim:trim
        }};
      });
      const result = api.recommend({cart:{items:sources}, products, vehiclesById,
        cartedIds:(this.dataset.carted || '').split(','), limitPerLine:1});
      const cards = [];
      function card(offer, context) {
        const fragment = templates.get(offer.product.id).content.cloneNode(true);
        const caption = fragment.querySelector('[data-offer-context]');
        if (context) caption.textContent = context;
        else caption.remove();
        return fragment;
      }
      for (const [i, line] of result.entries()) {
        for (const offer of line.recommendations) {
          const context = [sources[i].title, line.vehicleContext.year, line.vehicleContext.trim].filter(Boolean).join(' · ');
          cards.push(card(offer, context));
        }
      }
      const custom = result[0]?.customFitSuggestions[0];
      if (custom && !this.hasAttribute('data-product')) cards.push(card(custom, ''));
      output.replaceChildren(...cards);
      this.hidden = !cards.length;
      void related(this).catch(() => {});
      const fallback = this.closest('[data-ceika-build-complements],[data-ceika-complements]')?.querySelector('[data-ceika-development-request]');
      if (fallback) fallback.hidden = Boolean(cards.length);
    }
  }
  const scripts = new Map();
  function ready(globalName, url) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    if (!scripts.has(url)) scripts.set(url,new Promise((resolve,reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => resolve(window[globalName]);
      script.onerror = () => {scripts.delete(url); reject(Error('engine'));};
      document.head.append(script);
    }));
    return scripts.get(url);
  }
  // Siblings inserted in one render share a fresh cart read, never an earlier render's cart.
  let pendingCart;
  function freshCart(rootPath) {
    return pendingCart ||= fetch(rootPath+'cart.js',{cache:'no-store',credentials:'same-origin'})
      .then(r => {if (!r.ok) throw Error('cart');return r.json();}).finally(() => {pendingCart=null;});
  }
  class BuildOffer extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.render().catch(() => {}));
    }
    async render() {
      const {build,product,key,quantity,currency} = this.dataset;
      if (!api.buildIdOK(build)) return;
      const rootPath = window.Shopify?.routes?.root || '/';
      if (!/^\/(?:[a-z0-9-]+\/)*$/i.test(rootPath)) return;
      const [joint,controls,cart] = await Promise.all([ready('CeikaJointCommerce',this.dataset.joint),
        ready('CoiloverControls',this.dataset.controls),freshCart(rootPath)]);
      const parent = api.exactParent(cart,build,product);
      if (!this.isConnected || parent?.key !== key || parent.quantity !== Number(quantity) || cart.currency !== currency) return;
      const app = JSON.parse(this.querySelector('[data-application]').content.querySelector('[data-coil-application]').textContent);
      const binding = JSON.parse(this.querySelector('[data-binding]').content.textContent);
      if (app.productId !== product || binding.productId !== product || app.profile?.manualReview?.displayAllUnresolvedOptions) return;
      const state = joint.restoreCoilover(cart,binding,build).state;
      const variants = app.variants.filter(v => String(v.variantId) !== String(app.profile.pricing.basePriceVariantId) ||
        !(v.setup==='Legacy kit' && v.damper==='Existing configuration'));
      const compiled = controls.apply(app.profile,app.policy,variants);
      if (!compiled.profile.configuration.cores.includes(state.setup+'_'+state.damper)) return;
      const display = JSON.parse(parent.properties._ceika_display || '{}');
      const offer = api.upgrade({state, use:display.use, compiled, binding, parent, cart});
      if (!offer) return;
      const resp = await fetch(rootPath+'variants/'+offer.charge.variantId+'.js',{cache:'no-store',credentials:'same-origin'});
      if (!resp.ok) return;
      const variant = await resp.json();
      if (!this.isConnected || !api.currentCharge(variant,offer.charge)) return;
      const title = this.querySelector('[data-upgrade-title]');
      title.textContent = title.dataset[offer.label];
      const total = variant.price * parent.quantity;
      this.querySelector('[data-increase]').textContent = '+' + new Intl.NumberFormat(document.documentElement.lang || 'en',
        {style:'currency',currency}).format(total/100);
      this.hidden=false;
    }
  }
  customElements.define('ceika-build-offer', BuildOffer);

  customElements.define('ceika-reviewed-offers', ReviewedOffers);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function lineContext(line, contextByLineKey = {}) {
    const props = line?.properties || {};
    const raw = Object.hasOwn(contextByLineKey, line.key) ? contextByLineKey[line.key] : {
      vehicleId:props._ceika_vehicle_id, year:props._ceika_vehicle_year, trim:props._ceika_vehicle_trim
    };
    if (typeof raw?.vehicleId !== 'string' || !raw.vehicleId ||
        !/^\d{4}$/.test(String(raw.year ?? '')) || typeof raw.trim !== 'string' || !raw.trim) return null;
    return {vehicleId:raw.vehicleId, year:Number(raw.year), trim:raw.trim};
  }
  function reviewed(product, context, vehiclesById) {
    if (!context || !product || product.match_mode !== 'vehicle' || product.visible === false) return false;
    const v = vehiclesById[context.vehicleId];
    if (!v || !['active','reviewed'].includes(v.status) || v.variant !== context.trim ||
        !Number.isInteger(v.start_year) || !Number.isInteger(v.end_year) || context.year < v.start_year || context.year > v.end_year) return false;
    return product.assignments?.some(a => a.decision === 'reviewed' && (!a.status || ['active','reviewed'].includes(a.status)) &&
      a.vehicle_id === context.vehicleId && a.variant === context.trim && Number.isInteger(a.year_start) && Number.isInteger(a.year_end) &&
      context.year >= a.year_start && context.year <= a.year_end);
  }
  function recommend({cart, products = [], vehiclesById = {}, contextByLineKey = {}, cartedIds = [], limitPerLine = 4} = {}) {
    const lines = cart?.items || [];
    const excluded = new Set([...cartedIds, ...lines.map(l => l.product_id)].map(String));
    const unique = [...new Map(products.map(p => [String(p.id), p])).values()];
    const available = unique.filter(p => p.id && !excluded.has(String(p.id)) && p.available === true && p.visible !== false);
    const limit = Number.isInteger(limitPerLine) ? Math.min(8, Math.max(0,limitPerLine)) : 4;
    return lines.map(line => {
      const vehicleContext = lineContext(line, contextByLineKey);
      const source = unique.find(p => String(p.id) === String(line.product_id));
      const matched = reviewed(source, vehicleContext, vehiclesById) ? available.filter(p =>
        p.family !== source.family && p.family !== 'forged_wheels' && reviewed(p, vehicleContext, vehiclesById)) : [];
      const custom = available.filter(p => p.family === 'forged_wheels' && p.match_mode === 'custom');
      return {lineKey:line.key, vehicleContext,
        recommendations:matched.slice(0,limit).map(product => ({product, fitmentState:'reviewed_assignment'})),
        customFitSuggestions:custom.slice(0,limit).map(product => ({product, fitmentState:'custom'}))};
    });
  }
  const buildIdOK = id => /^coil-native-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
  function exactParent(cart, build, product) {
    if (!buildIdOK(build)) return null;
    const lines = cart.items.filter(l => l.properties?._ceika_build === build || l.properties?._ceika_coilover_build === build);
    const parents = lines.filter(l => !l.parent_relationship);
    const p = parents[0];
    if (parents.length!==1 || String(p.product_id)!==product || p.properties._ceika_role!=='kit' ||
        p.properties._ceika_coilover_role!=='kit' || !Number.isInteger(p.quantity) || p.quantity<1 || p.quantity>20) return null;
    if (lines.some(l => l.properties._ceika_build!==build || l.properties._ceika_coilover_build!==build ||
        l.properties._ceika_family!=='coilover' || String(l.properties._ceika_coilover_test)!==product ||
        (l!==p && (l.parent_relationship?.parent_key!==p.key || l.properties._ceika_role!=='upgrade')))) return null;
    const ids = String(p.properties._ceika_charge_ids || '').split('|').filter(Boolean).sort();
    const childIds = lines.filter(l=>l!==p).map(l=>String(l.variant_id)).sort();
    if (ids.length!==Number(p.properties._ceika_charge_count) || ids.join('|')!==childIds.join('|')) return null;
    return p;
  }
  function upgrade({state, use, compiled, binding, parent, cart}) {
    const front = compiled.profile.axles.front;
    let field, option, value, chargeKey, label;
    if ((use==='daily'||use==='rally'||(!use && state.setup==='comfort')) && state.helperScope==='none' &&
        front.layout.springPosition==='integrated' && front.spring.shape==='linear') {
      [field,option,value,chargeKey,label]=['helperScope','coil_helpers','front','front_helpers','helper'];
    } else if ((use==='spirited'||use==='track') && state.frontMount==='rubber' && front.layout.architecture==='macpherson') {
      [field,option,value,chargeKey,label]=['frontMount','coil_front_mount','pillowball','front_mount','mount'];
    } else return null;
    if (!compiled.enabled(field,value)) return null;
    const policy = binding.fullPolicies.find(p=>p.ownerId==='gid://shopify/ProductVariant/'+parent.variant_id)?.policy;
    if (!policy?.enabled || !policy.purchaseEnabled || policy.productId!=='gid://shopify/Product/'+parent.product_id) return null;
    const rule = policy.options[option], choice = rule?.values?.[value], charge=binding.chargeBindings[chargeKey];
    if (!charge || !/^\d+$/.test(charge.variantId) || !/^\d+$/.test(charge.productId) || !charge.sku ||
        rule.lockedValue || rule.when || choice?.when || choice?.whenAny || choice?.charges?.length!==1 ||
        choice.charges[0].variantId!=='gid://shopify/ProductVariant/'+charge.variantId || choice.charges[0].units!==1) return null;
    if (cart.items.some(l => l.properties?._ceika_build===parent.properties._ceika_build && String(l.variant_id)===String(charge.variantId))) return null;
    return {label,charge};
  }
  const currentCharge = (v,c) => v.available===true && String(v.id)===String(c.variantId) && v.sku===c.sku &&
    (v.product_id == null || String(v.product_id)===String(c.productId)) && Number.isSafeInteger(v.price) && v.price>0;

  return Object.freeze({recommend,lineContext,buildIdOK,exactParent,upgrade,currentCharge});
});
